import { EmergencyFundGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const EMERGENCY_FUND: BaseGoalConfig<EmergencyFundGoal> = {
    iconName: 'GoalEmergencyFund',
    color: colorsByGoalType['EMERGENCY_FUND'].primary,
    defaultName: 'Emergency fund',
    getDescription: () => 'Like a cash first aid kit for whatever life brings.',
    group: 'HIGH_YIELD_CASH_ONLY',
    blogLink: {
        description: 'See Plenty’s guide on emergency funds',
        url: 'https://www.withplenty.com/blog/rainy-day-ready-how-to-build-an-emergency-fund',
    },
    getAnnualReturn: ({ currentRateInfo }) => currentRateInfo.moneyMarketRate,
    getProgress: getProgressUsingTargetAmount,
};
